import React from 'react';
import { Box, Grid, Paper, Typography, Button, Stack, Divider } from '@mui/material';
import RolesList from './RolesList';
import RoleDetails from './RoleDetails';

const RolesPermissionsTab: React.FC = () => {
  const [selectedRoleId, setSelectedRoleId] = React.useState<string | null>(null);

  return (
    <Box sx={{ px: 3 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Role i uprawnienia</Typography>
        <Stack direction="row" spacing={1}>
          <Button variant="outlined">Anuluj</Button>
          <Button variant="contained">Zapisz</Button>
        </Stack>
      </Stack>

      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Role</Typography>
            </Stack>
            <Divider sx={{ mb: 1 }} />
            <RolesList selectedRoleId={selectedRoleId} onSelect={setSelectedRoleId} />
          </Paper>
        </Grid>
        <Grid item xs={12} md={8}>
          <Paper sx={{ p: 2 }}>
            <RoleDetails roleId={selectedRoleId} />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RolesPermissionsTab;


